import React from 'react';
import { Link } from 'react-router-dom';
import { FavoriteItem } from '../../types';
import Modal from '../Modal';
import Config from '../../Config';

interface Props {
    item: FavoriteItem,
    iconColor: string,
    onRemoveClicked: () => any,
}

interface State {
    modalOpen: boolean,
}

class LessonListItemView extends React.Component<Props, State> {
    state = {
        modalOpen: false,
    };

    openModal() {
        this.setState({ modalOpen: true });
    }

    closeModal() {
        this.setState({ modalOpen: false });
    }

    remove() {
        const { onRemoveClicked } = this.props;

        this.closeModal();
        onRemoveClicked();
    }

    render() {
        const { item, iconColor } = this.props;
        const { modalOpen } = this.state;

        return (
            <div className="list-item">
                <div className="d-flex align-items-center">
                    <div className="mental-icon">
                        <span className="bullet" style={{ backgroundColor: iconColor }} />
                    </div>
                    <div className="mental-name flex-grow-1">
                        <Link to={item.link || '#'}>
                            {item.title}
                        </Link>
                    </div>
                    <div className="mental-info">
                        <button onClick={() => this.openModal()} className="icon" type="button">
                            <i className="icon icon-options" />
                        </button>
                    </div>
                </div>
                {modalOpen ? (
                    <Modal closeWindowCallback={() => this.closeModal()}>
                        <h4 className="favorite-option-dialog-header">{item.title}</h4>
                        <ul className="modal-dialog-options-list">
                            <li className="option">
                                <button
                                    className="btn-control"
                                    onClick={() => this.remove()}
                                    type="button"
                                >
                                    <span className="option-icon">
                                        <img
                                            src={`${Config.publicImageUrl}/images/icon_favorite_active.svg`}
                                            alt=""
                                        />
                                    </span>
                                    <span className="option-text">
                                        Aus Favoriten entfernen
                                    </span>
                                </button>
                            </li>
                        </ul>
                    </Modal>
                ) : null}
            </div>
        );
    }
}

export default LessonListItemView;
